import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';

import { Beneficiary } from '@shared/models';

import { AccessControlPipe } from '../../../pipes/access-control.pipe';

export type BeneficiaryDetailsAction = 'DELETE' | 'SUSPEND' | 'UNSUSPEND';
@Component({
  selector: 'app-beneficiary-details-header',
  templateUrl: './beneficiary-details-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe, AccessControlPipe, RktIconComponent],
})
export class BeneficiaryDetailsHeaderComponent {
  @Input() beneficiary!: Beneficiary | null;
  @Input() isControlsDisabled = true;
  @Output() btnClicked = new EventEmitter<BeneficiaryDetailsAction>();
}
